import React from 'react';
import { Button, Result, Card } from 'antd';
import ContactTable from '../Contact/ContactTable/contact-table';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

interface RequesterSignatureProps {
  requesterData: any
  supplierData: any
}

const RequesterSignature: React.FC<RequesterSignatureProps> = ({ requesterData, supplierData }) => {
  const navigate = useNavigate(); // Initialize useNavigate

  const handleNavigate = () => {
    navigate('/dashboard'); // Replace with your actual route
  };

  return (
    <>
      <div className="card-section">
        <Card variant="borderless">
          <div id="requester-signature" className="initiate">
            <Result
              icon={null}
              title="Continue in Adobe Sign"
              subTitle={ <div style={{ display: 'flex', justifyContent: 'center' }}><p style={{ width: '65%', margin: 0 }}>Adobe Sign emails have been sent to the requesters. Requesters should sign the agreement using the link included in the email.</p></div> }
              extra={[
                <Button onClick={handleNavigate} key="buy">Dashboard</Button>,
              ]}
            />
          </div>
        </Card>
      </div>
      <div>
        <Card variant="borderless">
          <div id="requester-signature" className="initiate">
            <ContactTable
              id="view-requester"
              title="Requester"
              contacts={requesterData}
              showActions={false}
            />
          </div>
          <div style={{ marginTop: '2rem' }}>
            <ContactTable
              id="view-supplier"
              title="Supplier"
              contacts={supplierData}
              showActions={false}
            />
          </div>
        </Card>
      </div>
    </>
  );
};

export default RequesterSignature;
